import type { ESourceType, QueryParams } from "../../types";

export type ITopNonBrandKeywordsData = ITopNonBrandedDataRow[];
interface ITopNonBrandedDataRow {
    searchTerm: string;
    clicks: { numberOfClicks: number; shareOfClicks: number };
    yoyChange: { value: number; presentation: string };
    sitesClickShare?: Record<string, number>;
    percentageOf?: {
        organic: { formattedValue: string; numericValue: number };
        paid: { formattedValue: string; numericValue: number };
    };
}

export interface ITopNonBrandKeywordsResponse {
    [key: string]: {
        Clicks: number;
        ClicksShare: number;
        YoYChange: number;
        ChangePresentation: string;
        SitesClickShare?: Record<string, number>;
        OrganicClicks?: number;
        PaidClicks?: number;
    };
}
export const enum EPreset {
    HIGHLY_COMPETITIVE = "highlyCompetitive",
    OPPORTUNITIES = "opportunities",
    WINS = "wins",
}
export type ITopNonBrandedKeywordsQueryParams = QueryParams & { SourceType?: ESourceType; Preset?: EPreset };
